import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { projectFirestore } from "../../../firebase/config";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Table, Form, Pagination } from "react-bootstrap";
import {
  faPlus,
  faSearch,
  faSort,
  faTrash,
  faPencil,
  faUsd,
  faList,
  faCalendarWeek,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { onSnapshot, collection, doc, getDoc } from "firebase/firestore";
import { utilGetCollectionFilterReference } from "../../../util/UtilsFirebase";
import RecetaModal from "../../../components/RecetaModal";
import PreciosModal from "../../../components/PreciosModal";
import CategoriaModal from "./modal/CategoriaModal";
import PlatilloModal from "./modal/PlatilloModal";
import "./Menu.css";
import AñadidosModal from "./modal/AñadidosModal";
import IngredientesModal from "./modal/IngredientesModal";
import HorariosModal from "./modal/HorariosModal";

export default function Menu() {
  const [data, setData] = useState([]);
  const [dataPla, setDataPla] = useState([]);
  const [dataAnadidos, setDataAnadidos] = useState([]);
  const [dataIngrentes, setDataIngredientes] = useState([]);
  //const [collectionPath, setCollection] = useState("usersMobile")
  const [newCat] = useState(false);
  const [newPla] = useState(false);
  const { register } = useAuthContext();
  const [menu, setMenu] = useState([]);
  const [itemCategoria, setItemCategoria] = useState(null);
  const [itemPlatillo, setItemPlatillo] = useState(null);
  const [itemAnadido, setItemAnadido] = useState(null);
  const [itemHorarios, setItemHorarios] = useState(null);
  const [itemIngrediente, setItemIngredientes] = useState(null);
  const [mod, setMod] = useState(null);

  /* Filtros Tablas */

  const [filterText, setFilterText] = useState("");
  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  const filteredData = data.filter((item) => {
    return item.name.toLowerCase().includes(filterText.toLowerCase());
  });

  const [filterTextPla, setFilterTextPla] = useState("");
  const handleFilterTextChangePla = (event) => {
    setFilterTextPla(event.target.value);
  };
  const [filterTextAnadido, setFilterTextAnadido] = useState("");
  const handleFilterTextChangeAnadido = (event) => {
    setFilterTextAnadido(event.target.value);
  };
  const [filterTextIngredientes, setFilterTextIngredientes] = useState("");
  const handleFilterTextChangeIngredientes = (event) => {
    setFilterTextIngredientes(event.target.value);
  };

  const filteredDataPla = dataPla.filter((item) => {
    return (
      item.name.toLowerCase().includes(filterTextPla.toLowerCase()) ||
      item.categoria.name.toLowerCase().includes(filterTextPla.toLowerCase()) ||
      item.description.toLowerCase().includes(filterTextPla.toLowerCase())
    );
  });

  const filteredDataAnadido = dataAnadidos.filter((item) => {
    return (
      item.name.toLowerCase().includes(filterTextAnadido.toLowerCase()) ||
      item.precio.toLowerCase().includes(filterTextAnadido.toLowerCase()) ||
      item.medida.toLowerCase().includes(filterTextAnadido.toLowerCase()) ||
      item.categorias.filter((it) => {
        let va = it.toLowerCase().includes(filterTextAnadido.toLowerCase());
        return va;
      }).length > 0
    );
  });
  const filteredDataIngredientes = dataIngrentes.filter((item) => {
    return (
      item.name.toLowerCase().includes(filterTextIngredientes.toLowerCase()) ||
      item.cantidad
        .toLowerCase()
        .includes(filterTextIngredientes.toLowerCase()) ||
      item.categorias.filter((it) => {
        let va = it
          .toLowerCase()
          .includes(filterTextIngredientes.toLowerCase());
        return va;
      }).length > 0
    );
  });

  /* Ordenar tablas */

  const [sortType, setSortType] = useState("asc");
  const [sortTypePla, setSortTypePla] = useState("asc");

  /* Paginado Tablas */

  const [currentPage, setCurrentPage] = useState(1);
  const elementsPerPage = 7;
  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };
  const [currentPagePla, setCurrentPagePla] = useState(1);
  const getElementsForPagePla = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredDataPla.slice(startIndex, endIndex);
  };
  const [currentPageAnadido, setCurrentPageAnadido] = useState(1);
  const getElementsForPageAnadido = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredDataAnadido.slice(startIndex, endIndex);
  };
  const [currentPageIngredientes, setCurrentPageIngredientes] = useState(1);
  const getElementsForPageIngredientes = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredDataIngredientes.slice(startIndex, endIndex);
  };

  /* Modal Categoria */

  const [showCatForm, setShowCatForm] = useState(false);
  const handleCloseCategoria = () => {
    setShowCatForm(false);
  };
  const [showHorForm, setShowHorForm] = useState(false);
  const handleCloseHorarios = () => {
    setShowHorForm(false);
  };
  const [showPlatForm, setShowPlatForm] = useState(false);
  const handleClosePlatillo = () => {
    setShowPlatForm(false);
  };
  const [showReceta, setShowReceta] = useState(false);
  const handleCloseReceta = () => {
    setShowReceta(false);
  };
  const [showAñadidos, setShowAñadidos] = useState(false);
  const handleCloseAñadidos = () => {
    setShowAñadidos(false);
  };
  const [showIngredientes, setShowIngredientes] = useState(false);
  const handleCloseIngredientes = () => {
    setShowIngredientes(false);
  };
  const [showPrecios, setShowPrecios] = useState(false);
  const handleClosePrecios = () => {
    setShowPrecios(false);
  };

  //table

  useEffect(() => {
    async function getMenu() {
      const menuH = await utilGetCollectionFilterReference(
        "menu",
        "registro",
        "==",
        register.id,
        "registro",
      );
      let q = doc(projectFirestore, "menu", menuH[0].id);
      const docSnapshot = await getDoc(q);
      if (docSnapshot.exists()) {
        setMenu(docSnapshot);
        let documentosColeccionCat = [];
        onSnapshot(collection(q, "categoria"), (docs) => {
          documentosColeccionCat = [];
          docs.docs.forEach((doc) => {
            const data = doc.data();
            data.id = doc.id;
            documentosColeccionCat.push(data);
          });
          setData(documentosColeccionCat);
        });
        onSnapshot(collection(q, "platillo"), (docs) => {
          const documentosColeccion = [];
          docs.docs.forEach(async (doc) => {
            const data = doc.data();
            data.id = doc.id;
            data.categoria = documentosColeccionCat.filter((s) => {
              return s.id === data.categoria.id;
            })[0];
            documentosColeccion.push(data);
          });
          setDataPla(documentosColeccion);
        });
        onSnapshot(collection(q, "anadidos"), (docs) => {
          const documentosColeccion = [];
          docs.docs.forEach(async (doc) => {
            const data = doc.data();
            data.id = doc.id;
            documentosColeccion.push(data);
          });
          setDataAnadidos(documentosColeccion);
        });
        onSnapshot(collection(q, "ingredientes"), (docs) => {
          const documentosColeccion = [];
          docs.docs.forEach(async (doc) => {
            const data = doc.data();
            data.id = doc.id;
            documentosColeccion.push(data);
          });
          setDataIngredientes(documentosColeccion);
        });
      }
    }
    getMenu();
  }, [register.id]);

  const addCat = async (e) => {
    setMod("ADD");
    let item = { img: null, name: "", active: true };
    setItemCategoria(item);
    setShowCatForm(true);
  };
  const updCat = async (item) => {
    setMod("UPD");
    setItemCategoria(item);
    setShowCatForm(true);
  };
  const delCat = async (item) => {
    setMod("DLT");
    setItemCategoria(item);
    setShowCatForm(true);
  };
  const addPla = async (e) => {
    setMod("ADD");
    let item = {
      available: true,
      ncosto1: null,
      ncosto2: null,
      ncosto3: null,
      costo1: null,
      costo2: null,
      costo3: null,
      description: "",
      img: "",
      name: "",
      show: true,
    };
    setItemPlatillo(item);
    setShowPlatForm(true);
  };
  const updPla = async (item) => {
    setMod("UPD");
    setItemPlatillo(item);
    setShowPlatForm(true);
  };
  const updReceta = async (item) => {
    setMod("UPD");
    setItemPlatillo(item);
    setShowReceta(true);
  };
  const updHorarios = async (item) => {
    setMod("UPD");
    setItemHorarios(item);
    setShowHorForm(true);
  };
  const updAñadidos = async (item) => {
    setMod("UPD");
    setItemAnadido(item);
    setShowAñadidos(true);
  };
  const addAñadidos = async () => {
    setMod("ADD");
    setShowAñadidos(true);
  };
  const delAñadidos = async (item) => {
    setMod("DLT");
    setItemAnadido(item);
    setShowAñadidos(true);
  };
  const updIngredientes = async (item) => {
    setMod("UPD");
    setItemIngredientes(item);
    setShowIngredientes(true);
  };
  const addIngredientes = async () => {
    setMod("ADD");
    setShowIngredientes(true);
  };
  const delIngredientes = async (item) => {
    setMod("DLT");
    setItemIngredientes(item);
    setShowIngredientes(true);
  };
  const updPrecios = async (item) => {
    setMod("UPD");
    setItemPlatillo(item);
    setShowPrecios(true);
  };
  const delPla = async (item) => {
    setMod("DLT");
    setItemPlatillo(item);
    setShowPlatForm(true);
  };

  return (
    <div>
      <br />
      <h4 className="page-title">MENÚ</h4>
      <br />
      <hr />
      <div className="container">
        <>
          <ToastContainer />
          <Tabs>
            <TabList>
              <Tab>Categorias</Tab>
              <Tab>Platillos</Tab>
              <Tab>Añadidos</Tab>
              <Tab>Ingredientes</Tab>
            </TabList>
            <TabPanel>
              <br />
              <div className="row">
                <div className="col-sm-3">
                  <div className="input-group">
                    <Form.Control
                      className="form-control border-end-0 border rounded-pill"
                      type="text"
                      aria-describedby="search-icon"
                      placeholder="Busqueda general"
                      value={filterText}
                      onChange={handleFilterTextChange}
                    />
                    <span className="input-group-append">
                      <button
                        className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                        type="button"
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Table
                    className="table-menu"
                    striped
                    bordered
                    hover
                    border="2"
                    id="ex-tblMenu"
                  >
                    <tbody>
                      <tr>
                        <th className="width-tbl10">Icono</th>
                        <th
                          className="width-tbl60"
                          onClick={() =>
                            setSortType(sortType === "asc" ? "desc" : "asc")
                          }
                        >
                          {" "}
                          <FontAwesomeIcon icon={faSort} /> Nombre
                        </th>
                        <th className="width-tbl10">Mostrar</th>
                        <th className="width-tbl10"></th>
                        <th className="width-tbl10"></th>
                      </tr>
                      {data &&
                        getElementsForPage(currentPage)
                          .sort()
                          .map((val, key) => {
                            return (
                              <tr key={key}>
                                <td>
                                  <label className="lblImg">
                                    <img alt="" id="newCat" src={val.img} />
                                  </label>
                                </td>
                                <td>{val.name}</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    disabled={true}
                                    checked={val?.active}
                                  />
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => updCat(val)}
                                    className="btn btn-primary"
                                  >
                                    <FontAwesomeIcon icon={faPencil} />
                                  </button>
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => delCat(val)}
                                    className="btn btn-danger"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </Table>
                  <Pagination>
                    {Array.from({
                      length: Math.ceil(filteredData.length / elementsPerPage),
                    }).map((page, index) => (
                      <Pagination.Item
                        key={index}
                        active={index + 1 === currentPage}
                        className={
                          index + 1 === currentPage ? "btn-paginado" : ""
                        }
                        onClick={() => setCurrentPage(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                </div>
                <br />
                <div className="col-sm-12 left">
                  <button
                    hidden={!data}
                    className="btn btn-primary"
                    onClick={addCat}
                    disabled={newCat}
                  >
                    {" "}
                    <FontAwesomeIcon icon={faPlus} /> AGREGAR
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <br />
              <div className="row">
                <div className="col-sm-3">
                  <div className="input-group">
                    <Form.Control
                      className="form-control border-end-0 border rounded-pill"
                      type="text"
                      aria-describedby="search-icon"
                      placeholder="Busqueda general"
                      value={filterTextPla}
                      onChange={handleFilterTextChangePla}
                    />
                    <span className="input-group-append">
                      <button
                        className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                        type="button"
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Table
                    className="table-menu"
                    striped
                    bordered
                    hover
                    border="2"
                    id="ex-tblResMenu"
                  >
                    <tbody>
                      <tr>
                        <th className="width-tbl10">Foto</th>
                        <th
                          className="width-tbl20"
                          onClick={() =>
                            setSortTypePla(
                              sortTypePla === "asc" ? "desc" : "asc",
                            )
                          }
                        >
                          {" "}
                          <FontAwesomeIcon icon={faSort} /> Nombre
                        </th>
                        <th className="width-tbl20">Categoria</th>
                        <th className="width-tbl60">Descripcion</th>
                        <th className="width-tbl10">Mostrar</th>
                        <th className="width-tbl10">Disponible</th>
                        <th style={{ textAlign: "center" }}>Modo de venta</th>
                        <th>Receta</th>
                        <th>Precios</th>
                        <th>Modificar</th>
                        <th>Eliminar</th>
                      </tr>
                      {dataPla &&
                        getElementsForPagePla(currentPagePla)
                          .sort()
                          .map((val, key) => {
                            return (
                              <tr key={key}>
                                <td className="tbl10">
                                  <label className="lblImg">
                                    <img alt="" id="newCat" src={val.img} />
                                  </label>
                                </td>
                                <td className="tbl10">{val.name}</td>
                                <td className="tbl10">{val.categoria?.name}</td>
                                <td>{val.description}</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    disabled={true}
                                    checked={val?.show}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="checkbox"
                                    disabled={true}
                                    checked={val?.available}
                                  />
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => updHorarios(val)}
                                    className="btn btn-dark"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faCalendarWeek} />
                                  </button>
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => updReceta(val)}
                                    className="btn btn-info"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faList} />
                                  </button>
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => updPrecios(val)}
                                    className="btn btn-success"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faUsd} />
                                  </button>
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => updPla(val)}
                                    className="btn btn-primary"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faPencil} />
                                  </button>
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => delPla(val)}
                                    className="btn btn-danger"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </Table>
                  <Pagination>
                    {Array.from({
                      length: Math.ceil(
                        filteredDataPla.length / elementsPerPage,
                      ),
                    }).map((page, index) => (
                      <Pagination.Item
                        key={index}
                        active={index + 1 === currentPagePla}
                        className={
                          index + 1 === currentPagePla ? "btn-paginado" : ""
                        }
                        onClick={() => setCurrentPagePla(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                </div>
                <br />
                <div className="col-sm-12 left">
                  <button
                    hidden={!dataPla}
                    className="btn btn-primary"
                    onClick={addPla}
                    disabled={newPla}
                  >
                    {" "}
                    <FontAwesomeIcon icon={faPlus} /> AGREGAR
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <br />
              <div className="row">
                <div className="col-sm-3">
                  <div className="input-group">
                    <Form.Control
                      className="form-control border-end-0 border rounded-pill"
                      type="text"
                      aria-describedby="search-icon"
                      placeholder="Busqueda general"
                      value={filterTextAnadido}
                      onChange={handleFilterTextChangeAnadido}
                    />
                    <span className="input-group-append">
                      <button
                        className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                        type="button"
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Table
                    className="table-menu"
                    striped
                    bordered
                    hover
                    border="2"
                    id="ex-tblResMenu"
                  >
                    <tbody>
                      <tr>
                        <th className="width-tbl10">Foto</th>
                        <th
                          className="width-tbl20"
                          onClick={() =>
                            setSortTypePla(
                              sortTypePla === "asc" ? "desc" : "asc",
                            )
                          }
                        >
                          {" "}
                          <FontAwesomeIcon icon={faSort} /> Nombre
                        </th>
                        <th className="width-tbl10">Precio</th>
                        <th className="width-tbl10">Unidad</th>
                        <th>Categorias</th>
                        <th>Editar</th>
                        <th>Eliminar</th>
                      </tr>
                      {dataPla &&
                        getElementsForPageAnadido(currentPageAnadido)
                          .sort()
                          .map((val, key) => {
                            return (
                              <tr key={key}>
                                <td className="tbl10">
                                  <label className="lblImg">
                                    <img alt="" id="newCat" src={val.img} />
                                  </label>
                                </td>
                                <td className="tbl10">{val.name}</td>
                                <td>
                                  {val.free ? "Gratis" : "$ " + val.precio}
                                </td>
                                <td>{val.medida}</td>
                                <td>
                                  {val.categorias.map((cat, index) => (
                                    <span key={index}>
                                      {cat}
                                      {index + 1 < val.categorias.length
                                        ? ","
                                        : ""}{" "}
                                    </span>
                                  ))}
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => updAñadidos(val)}
                                    className="btn btn-primary"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faPencil} />
                                  </button>
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => delAñadidos(val)}
                                    className="btn btn-danger"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </Table>
                  <Pagination>
                    {Array.from({
                      length: Math.ceil(
                        filteredDataAnadido.length / elementsPerPage,
                      ),
                    }).map((page, index) => (
                      <Pagination.Item
                        key={index}
                        active={index + 1 === currentPageAnadido}
                        className={
                          index + 1 === currentPageAnadido ? "btn-paginado" : ""
                        }
                        onClick={() => setCurrentPageAnadido(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                </div>
                <br />
                <div className="col-sm-12 left">
                  <button
                    hidden={!dataAnadidos}
                    className="btn btn-primary"
                    onClick={addAñadidos}
                    disabled={newPla}
                  >
                    {" "}
                    <FontAwesomeIcon icon={faPlus} /> AGREGAR
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <br />
              <div className="row">
                <div className="col-sm-3">
                  <div className="input-group">
                    <Form.Control
                      className="form-control border-end-0 border rounded-pill"
                      type="text"
                      aria-describedby="search-icon"
                      placeholder="Busqueda general"
                      value={filterTextIngredientes}
                      onChange={handleFilterTextChangeIngredientes}
                    />
                    <span className="input-group-append">
                      <button
                        className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                        type="button"
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Table
                    className="table-menu"
                    striped
                    bordered
                    hover
                    border="2"
                    id="ex-tblResMenu"
                  >
                    <tbody>
                      <tr>
                        <th
                          className="width-tbl20"
                          onClick={() =>
                            setSortTypePla(
                              sortTypePla === "asc" ? "desc" : "asc",
                            )
                          }
                        >
                          Nombre
                        </th>
                        <th>Cantidad permitida</th>
                        <th>Categorias</th>
                        <th></th>
                        <th></th>
                      </tr>
                      {dataPla &&
                        getElementsForPageIngredientes(currentPageIngredientes)
                          .sort()
                          .map((val, key) => {
                            return (
                              <tr key={key}>
                                <td className="tbl10">{val.name}</td>
                                <td>{val.cantidad}</td>
                                <td>
                                  {val.categorias.map((cat, index) => (
                                    <span key={index}>
                                      {cat}
                                      {index + 1 < val.categorias.length
                                        ? ","
                                        : ""}{" "}
                                    </span>
                                  ))}
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => updIngredientes(val)}
                                    className="btn btn-primary"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faPencil} />
                                  </button>
                                </td>
                                <td className="center-mn">
                                  <button
                                    onClick={() => delIngredientes(val)}
                                    className="btn btn-danger"
                                    id="BtnOption"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </Table>
                  <Pagination>
                    {Array.from({
                      length: Math.ceil(
                        filteredDataIngredientes.length / elementsPerPage,
                      ),
                    }).map((page, index) => (
                      <Pagination.Item
                        key={index}
                        active={index + 1 === currentPageIngredientes}
                        className={
                          index + 1 === currentPageIngredientes
                            ? "btn-paginado"
                            : ""
                        }
                        onClick={() => setCurrentPageIngredientes(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                </div>
                <br />
                <div className="col-sm-12 left">
                  <button
                    hidden={!dataIngrentes}
                    className="btn btn-primary"
                    onClick={addIngredientes}
                    disabled={newPla}
                  >
                    {" "}
                    <FontAwesomeIcon icon={faPlus} /> AGREGAR
                  </button>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </>
        <br />
        <br />
      </div>

      <CategoriaModal
        menu={menu}
        showCategoria={showCatForm}
        mod={mod}
        itemCategoria={itemCategoria}
        handleCloseCategoria={handleCloseCategoria}
      />
      <PlatilloModal
        menu={menu}
        showPlatillo={showPlatForm}
        mod={mod}
        ingredientes={dataIngrentes}
        agregados={dataAnadidos}
        itemPlatillo={itemPlatillo}
        handleClosePlatillo={handleClosePlatillo}
        datacategorias={data}
      />
      <RecetaModal
        menu={menu}
        showReceta={showReceta}
        mod={"UPD"}
        itemPlatillo={itemPlatillo}
        handleCloseReceta={handleCloseReceta}
      />
      <AñadidosModal
        menu={menu}
        showReceta={showAñadidos}
        mod={mod}
        categorias={data}
        itemAnadido={itemAnadido}
        handleCloseAñadido={handleCloseAñadidos}
      />
      <IngredientesModal
        menu={menu}
        showReceta={showIngredientes}
        mod={mod}
        categorias={data}
        itemAnadido={itemIngrediente}
        handleCloseAñadido={handleCloseIngredientes}
      />
      <PreciosModal
        menu={menu}
        showPrecios={showPrecios}
        mod={"UPD"}
        itemPlatillo={itemPlatillo}
        handleClosePrecios={handleClosePrecios}
      />
      <HorariosModal
        menu={menu}
        show={showHorForm}
        mod={mod}
        item={itemHorarios}
        handleClose={handleCloseHorarios}
      />
    </div>
  );
}
